import { Card, Space, Statistic } from 'antd';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import apiCall from 'apps/futureflex/apiCalls/employeeProgram';
import ErrorMessage from 'common/ui/ErrorMessage';
import LoadingSpinner from 'common/ui/LoadingSpinner';
import { useFetchApiGet } from 'hooks/api';
import { getChangeValueColor } from 'utils/color';
import { formatCurrency, formatNumber } from 'utils/formatAmount';

function ProgramDetailPortfolio() {
  const params = useParams();

  const { data, isLoading: isLoadingPort, error: errorPort, load } = useFetchApiGet(
    apiCall.portfolio,
    { resourceName: 'data' }
  );

  useEffect(() => {
    if (params.id) load(params);
  }, [params.id]);

  if (isLoadingPort || (!data && !errorPort)) {
    return <LoadingSpinner />;
  }
  if (errorPort) {
    return <ErrorMessage errors={JSON.stringify(errorPort)} />;
  }

  const {
    total_summary,
    company_summary,
    employee_summary,
    projected_program_amount,
  } = data || {};

  return (
    <div className="flex flex-col gap-6">
      <Contribute {...total_summary} />
      <Contribute {...company_summary} />
      <Contribute {...employee_summary} />
    </div>
  );
}

export const Contribute = ({
  side,
  contributed_amount,
  market_value,
  unrealized_gain_loss_amount,
  unrealized_gain_loss_percentage,
  cert_subscription_amount,
}) => (
  <Card title={side?.toUpperCase()}>
    <Space size="large">
      <Statistic
        title="Contributed amount"
        value={contributed_amount}
        formatter={value => formatCurrency(value)}
      />
      <Statistic
        title="Vốn mua"
        value={cert_subscription_amount}
        formatter={value => formatCurrency(value)}
      />
      <Statistic
        title="AUM"
        value={market_value}
        formatter={value => formatCurrency(value)}
      />
      <Statistic
        valueStyle={{ color: getChangeValueColor(unrealized_gain_loss_amount) }}
        title="Unrealized Gain Loss"
        value={unrealized_gain_loss_amount}
        formatter={value => formatCurrency(value)}
        suffix={`(${formatNumber(unrealized_gain_loss_percentage)}%)`}
      />
    </Space>
  </Card>
);

export default ProgramDetailPortfolio;
